import View                    from '@widesk-ui/components/View';
import { observer }            from 'mobx-react-lite';
import BadgeDisplayField       from '@/TokamapEditor/ux/AreaSidebar/BadgeDisplayField';
import AreaImageSection        from '@/TokamapEditor/ux/AreaSidebar/AreaImageSection';
import AreaTextSection         from '@/TokamapEditor/ux/AreaSidebar/AreaTextSection';

const AreaContentSection = observer(() => (
	<View gap="lg">
		<BadgeDisplayField />
		<AreaImageSection />
		<AreaTextSection />
	</View>
));

export default AreaContentSection;
